import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Ressource } from '../../_interfaces/ressource';
import {
  Firestore,
  CollectionReference,
  addDoc,
  collection,
  deleteDoc,
  doc,
  updateDoc,
} from 'firebase/firestore';
import { FirebaseService } from '../../_firebase/firebase.service';

@Injectable({
  providedIn: 'root'
})
export class RessourceService {
  private firebase: FirebaseService = inject(FirebaseService);
  private firestore: Firestore = this.firebase.firestore;
  private ressourcesCol: CollectionReference = collection(this.firestore, 'ressources');

  getAllRessources(): Observable<Ressource[]> {
    return this.firebase.collectionData(this.ressourcesCol, { idField: 'key' }).pipe(
      map(docs => docs as Ressource[])
    );
  }

  getRessourceById(id: string): Promise<Ressource | null> {
    return this.firebase.getDoc(doc(this.firestore, 'ressources', id)).then(snapshot => {
      if (!snapshot.exists()) return null;
      return { key: snapshot.id, ...(snapshot.data() as Omit<Ressource, 'key'>) };
    });
  }

  createRessource(ressource: Ressource) {
    const { key, ...data } = ressource;
    return addDoc(this.ressourcesCol, data);
  }

  updateRessource(id: string, ressource: Ressource) {
    const { key, ...data } = ressource;
    return updateDoc(doc(this.firestore, 'ressources', id), data);
  }

  deleteRessource(id: string) {
    return deleteDoc(doc(this.firestore, 'ressources', id));
  }
}
